import React, { FC } from 'react'
import { ShipperFacilityHour } from 'apps/marketplace/apiTypes/shipperFacilities'
import { HourBlock } from './HourBlock'

export interface IFacilityHoursSingleSetProps {
  hours: ShipperFacilityHour
}

export const FacilityHoursSingleSet: FC<IFacilityHoursSingleSetProps> = ({ hours }) => {
  return <HourBlock hours={hours} />
}
